import React, { Fragment } from "react";
import Area from "./Area";
import City from "./City";
import Neighborhood from "./Neighborhood";
import Street from "./Street";
import Zipcode from "./Zipcode";
import District from "./District";
import HouseNumber from "./HouseNumber";
import HouseNumberExtension from "./HouseNumberExtension";
import { AddressFields } from "@/shared/utils/countryConfig";
import useCountryConfigHook from "@/shared/hooks/useCountryConfigHook";
import Floor from "./Floor";

const AddressFieldMap: Record<AddressFields, React.ReactNode> = {
  floor: <Floor />,
  houseNumber: <HouseNumber />,
  houseNumberExtension: <HouseNumberExtension />,
  area: <Area />,
  city: <City />,
  district: <District />,
  neighborhood: <Neighborhood />,
  street: <Street />,
  zipcode: <Zipcode />,
};

const FormOrderUserAddress = () => {
  const {
    address: { fields },
  } = useCountryConfigHook();

  const firstRowFields = fields[0];
  const secondRowFields = fields[1];
  const thirdRowFields = fields[2];

  return (
    <>
      <div className={`grid grid-cols-${firstRowFields.length} gap-2`}>
        {firstRowFields.map((fields, index) => (
          <div key={index} className={`grid grid-cols-${fields.length} gap-2`}>
            {fields.map((field, index) => (
              <Fragment key={index}>{AddressFieldMap[field]}</Fragment>
            ))}
          </div>
        ))}
      </div>
      <div className={`grid grid-cols-${secondRowFields.length} gap-2`}>
        {secondRowFields.map((fields, index) => (
          <div key={index} className={`grid grid-cols-${fields.length} gap-2`}>
            {fields.map((field, index) => (
              <Fragment key={index}>{AddressFieldMap[field]}</Fragment>
            ))}
          </div>
        ))}
      </div>
      {thirdRowFields && (
        <div className={`grid grid-cols-${thirdRowFields.length} gap-2`}>
          {thirdRowFields.map((fields, index) => (
            <div
              key={index}
              className={`grid grid-cols-${fields.length} gap-2`}
            >
              {fields.map((field, index) => (
                <Fragment key={index}>{AddressFieldMap[field]}</Fragment>
              ))}
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default FormOrderUserAddress;
